import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  DatetimePicker,
  Popup,
  Tab,
  Tabs,
  Image as VanImage,
  CountDown,
  Sticky,
  NoticeBar,
  Swipe,
  SwipeItem,
  Dialog,
  Toast,
  Field
} from "vant";
import "vant/lib/popup/style";
import "vant/lib/datetime-picker/style";
import "vant/lib/tab/style";
import "vant/lib/tabs/style";
import "vant/lib/image/style";
import "vant/lib/count-down/style";
import "vant/lib/notice-bar/style";
import "vant/lib/swipe/style";
import "vant/lib/swipe-item/style";
import "vant/lib/dialog/style";
import "vant/lib/toast/style";
import "vant/lib/field/style";
import GeminiScrollbar from "vue-gemini-scrollbar";
import VueWechatTitle from "vue-wechat-title";

import service from "./service";
import "./assets/scss/index.scss";
Vue.config.productionTip = false;
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(VanImage);
Vue.use(CountDown);
Vue.use(Sticky);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Field);
Vue.use(GeminiScrollbar);
Vue.use(VueWechatTitle);
Vue.use(service, {});
Vue.prototype.$vantDialog = Dialog;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
